import { createStore } from 'satcheljs';
export var getStartedStore = createStore('getStartedStore', {
    tasks: null,
});
//# sourceMappingURL=store.js.map